import React from 'react';
import './App.scss';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { GlobalStyles } from '@bigcommerce/big-design';
// Components
import Header from './components/layout/Header';
import Login from './components/layout/Login';
import useToken from './hooks/useToken';
// Pages
import Home from './components/pages/Home';
import PurchaseOrder from './components/pages/PurchaseOrder';
import Webhooks from './components/pages/Webhooks';
import Reviews from './components/pages/Reviews';

function App() {
  const { token, setToken } = useToken();

  if(!token) { 
    return (
      <Router>
        <div className="App">
          <GlobalStyles />
          <Header />
          <Login setToken={setToken} />
        </div>
      </Router>
    )
  }

  return (
    <Router>
      <div className="App">
        <GlobalStyles />
        <Header token={token} />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/purchase-order" element={<PurchaseOrder />} />
          <Route path="/webhooks" element={<Webhooks />} />
          <Route path="/reviews" element={<Reviews />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
